import { trackEvent } from './analytics';

// Fires a GA4 custom event so download counts per tool show up in
// Analytics → Reports → Engagement → Events, alongside page-view data.
function trackDownload(toolName) {
  trackEvent('download_click', { tool_name: toolName || 'unknown' });
}

// Forces a real same-tab download instead of a navigation.
//
// The browser's `download` attribute on <a href> is silently IGNORED for
// cross-origin URLs (per spec) — and our converted-file URLs point at the
// backend's own origin, which differs from the frontend's origin in dev
// and can differ in production too. Without this, clicking "Download"
// just navigates to the file, which browsers often open in a new tab
// instead of saving it. Fetching the file and downloading it via a
// same-origin blob: URL sidesteps the restriction entirely.
export async function downloadFile(url, filename, toolName) {
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Download failed (${res.status})`);
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
    trackDownload(toolName);
  } catch (err) {
    // Fall back to a plain navigation so the user still gets the file
    // (opens in a new tab / browser viewer) even if the fetch failed
    // (e.g. CORS on a misconfigured deployment).
    window.open(url, '_blank', 'noopener');
    trackDownload(toolName);
  }
}

// For results that are already raw text in memory (e.g. OCR output) rather
// than a file living at a server URL — builds the blob client-side instead
// of fetching one.
export function downloadText(text, filename, toolName) {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename || 'download.txt';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
  trackDownload(toolName);
}
